module.exports = __webpack_public_path__ + "img/ba.2c30a70b.png";